<p-confirmDialog key="login1" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="login2" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="login3" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="login4" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- <div class="middle-box text-center loginscreen animated fadeInDown"> -->
<div class="CustomMiddleBox text-center loginscreen animated fadeInDown MainDiv">
	<!--Logo and Info-->
	<div>
		<caass-login-logo
			[DistrictInfoLoading]="DistrictInfoLoading"
			[ShowDistrictName]="ShowDistrictName"
			[DistrictDisplayName]="DistrictDisplayName"
			[DistrictVersionNumber]="DistrictVersionNumber"
			[VersionChecked]="VersionChecked"
			[VersionMatch]="VersionMatch"
			[CAASS_VERSION]="CAASS_VERSION"
			[errorMessage]="errorMessage"
		></caass-login-logo>

		<!--Normal Login, Step 1-->
		<div *ngIf="LoginStep == 1 && VersionMatch == true && HideNormalLogin == false">
			<p>Please type your Username & Password to Login.</p>
		</div>

		<div
			*ngIf="LoginStep == 1 && VersionMatch == true && HideNormalLogin == false && LoginPageAlert != null && LoginPageAlert != ''"
			class="alert alert-info"
		>
			<p [innerHTML]="LoginPageAlert"></p>
		</div>

		<!--Is the user registered for MFA?-->
		<div *ngIf="LoginStep == 2 && VersionMatch == true && HideNormalLogin == false">
			<caass-mfa-instructions [QRImage]="QRImage" [ManualCode]="ManualCode"></caass-mfa-instructions>
		</div>

		<!--MFA, Step 3 (If MFA pref is on)-->
		<div *ngIf="LoginStep == 3 && VersionMatch == true">
			<p>Please enter the code from your Google Authenticator or Microsoft Authenticator App</p>
		</div>
	</div>

	<!--Input-->
	<div *ngIf="VersionMatch == true">
		<!--Step 1-->
		<div *ngIf="LoginStep == 1" class="Grid1Col">
			<input
				*ngIf="HideNormalLogin == false"
				[disabled]="IsLoading() == true"
				class="form-control MaxButtonWidth"
				type="text"
				placeholder="Username"
				[(ngModel)]="Username"
			/>
			<form *ngIf="HideNormalLogin == false">
				<input
					name="Password"
					[disabled]="IsLoading() == true"
					class="form-control MaxButtonWidth"
					type="password"
					placeholder="Password"
					[(ngModel)]="Password"
				/>
			</form>
			<button
				*ngIf="HideNormalLogin == false"
				id="LoginButton"
				[disabled]="IsLoading() == true"
				class="btn btn-primary MaxButtonWidth"
				(click)="onLogin()"
			>
				Login
			</button>

			<div>
				<div *ngFor="let o of lstIdentityProvider" style="margin-bottom: 5px">
					<button
						*ngIf="o.ButtonTypeID == 1"
						[disabled]="IsLoading() == true"
						class="btn btn-primary MaxButtonWidth SSOHover"
						[style.Background]="o.LoginButtonBackground"
						[style.Border-Color]="o.LoginButtonBackground == '#ffffff' ? '#000000' : o.LoginButtonBackground"
						[style.color]="o.LoginButtonForeground"
						[style.padding]="o.HasIcon == true ? '0px' : '6px 12px'"
						(click)="onSSOButton(o)"
					>
						<img class="SSOButtonIcon" *ngIf="o.HasIcon == true" [src]="o.LoginButtonIconLink" />
						{{ o.LoginButtonDesc }}
					</button>

					<button
						class="gsi-material-button"
						style="width: 300px"
						*ngIf="o.ButtonTypeID == 2"
						[disabled]="IsLoading() == true"
						(click)="onSSOButton(o)"
					>
						<div class="gsi-material-button-state"></div>
						<div class="gsi-material-button-content-wrapper">
							<div class="gsi-material-button-icon">
								<svg
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 48 48"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									style="display: block"
								>
									<path
										fill="#EA4335"
										d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
									></path>
									<path
										fill="#4285F4"
										d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
									></path>
									<path
										fill="#FBBC05"
										d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
									></path>
									<path
										fill="#34A853"
										d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
									></path>
									<path fill="none" d="M0 0h48v48H0z"></path>
								</svg>
							</div>
							<span class="gsi-material-button-contents">Sign in with Google</span>
							<span style="display: none">Sign in with Google</span>
						</div>
					</button>
				</div>
			</div>
		</div>

		<div *ngIf="LoginStep == 2" class="Grid1Col">
			<button id="FinishRegisterButton" [disabled]="IsLoading() == true" class="btn btn-primary MaxButtonWidth" (click)="onCheckMFA()">Continue</button>
			<button [disabled]="IsLoading() == true" class="btn btn-warning MaxButtonWidth" (click)="onCancelRegister()">Cancel</button>
		</div>

		<!--Step 3-->
		<div *ngIf="LoginStep == 3" class="Grid1Col">
			<input
				[disabled]="IsLoading() == true"
				class="form-control MaxButtonWidth"
				type="text"
				placeholder="Multi-Factor Authentication Code"
				[(ngModel)]="MFACode"
			/>
			<button id="LoginMFAButton" [disabled]="IsLoading() == true" class="btn btn-primary MaxButtonWidth" (click)="onLoginStep2()">Login</button>
			<button [disabled]="IsLoading() == true" class="btn btn-warning MaxButtonWidth" (click)="onCancelMFA()">Cancel</button>
		</div>
	</div>

	<!--Forgot password or username-->
	<div *ngIf="VersionMatch == true && HideNormalLogin == false" class="SmallTopMargin">
		<button [disabled]="IsLoading() == true" class="LinkButton" (click)="onForgotPassword()">
			<small>Forgot Password?</small>
		</button>
		<button [disabled]="IsLoading() == true" class="LinkButton" (click)="onForgotUserName()">
			<small>Forgot Username?</small>
		</button>
	</div>

	<div *ngIf="VersionMatch == true && HideNormalLogin == false" class="SmallTopMargin">
		<button [disabled]="IsLoading() == true" class="LinkButton" (click)="onForgotMFA()">
			<small>Forgot MFA?</small>
		</button>
	</div>

	<div *ngIf="VersionMatch == true" class="TopMargin">
		<p class="ConfidentialText">* My Username and Password are the equivalent of my signature.</p>
		<p class="ConfidentialText">* I am responsible for the data I enter and the information I access.</p>
	</div>

	<!--Access 411 Logo-->
	<div style="margin-top: 75px">
		<div>
			<a target="_blank" href="https://www.access411.com"> <img alt="www.access411.com" src="assets/images/access411-bluelogo.png" width="50" /></a>
		</div>

		<div>
			<p class="m-t"><small>Access411 &copy;2025</small></p>
		</div>
	</div>
</div>
